
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M13.5 6.3h-2.7V.9H7.2v5.4H4.5L9 10.8l4.5-4.5zm3.904 5.879c-.189-.202-1.45-1.55-1.81-1.903a1.353 1.353 0 00-.938-.376h-1.58l2.757 2.695h-3.19a.247.247 0 00-.216.12l-.734 1.685H6.307l-.734-1.686a.249.249 0 00-.216-.12h-3.19L4.924 9.9h-1.58c-.358 0-.699.143-.938.376-.36.353-1.621 1.702-1.81 1.903-.44.469-.682.842-.567 1.304l.505 2.767c.115.462.622.842 1.127.842h14.68c.505 0 1.012-.38 1.127-.842l.505-2.767c.113-.462-.128-.835-.569-1.304z"}})])
          )
        }
      }
    